import { render, staticRenderFns } from "./ClientReplicaTable.vue?vue&type=template&id=87389ffe&scoped=true"
import script from "./ClientReplicaTable.vue?vue&type=script&lang=js"
export * from "./ClientReplicaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87389ffe",
  null
  
)

export default component.exports